<h4 class="form-label-h4">
    {{ to.label }}
    <span class="tt" *ngIf="to.title">
        <fa-icon class="ms-2" [icon]="faInfoSign"></fa-icon>
        <span class="tttext">{{ to.title }}</span>
    </span>
</h4>
<div class="btn-group">
    <div
        class="me-2 margin-bottom-5"
        [ngStyle]="{ 'min-width.px': dmsButton.minWidth }"
        *ngFor="let dmsButton of to.dmsButtons"
    >
        <button
            *ngIf="!dmsButton.isHidden && !dmsButton.isDrawingRegister"
            class="btn btn-secondary"
            type="button"
            data-bs-toggle="modal"
            (click)="onChangeDmsUrl(dmsButton.url)"
            [attr.data-bs-target]="'#documents-modal-' + to.id"
        >
            {{ dmsButton.name }}
        </button>
        <button
            *ngIf="!dmsButton.isHidden && dmsButton.isDrawingRegister"
            class="btn btn-secondary"
            type="button"
            (click)="openDrawingRegisterModal()"
        >
            {{ dmsButton.name }}
        </button>
    </div>
</div>
<div
    #modal
    class="modal fade"
    id="documents-modal-{{ to.id }}"
    tabindex="-1"
    role="dialog"
>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    #closeModalButton
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                >
                </button>
            </div>
            <div class="modal-body" *ngIf="showModal">
                <div class="container-fluid">
                    <dms
                        [path]="selectedPath"
                        [selectionMode]="selectionMode"
                        [(selection)]="selectedDocuments"
                        (selectionChange)="selectionChanged()"
                        [allowContextMenu]="true"
                        [skipProjectId]="to.skipProjectId"
                        [isFileInput]="true"
                    ></dms>
                </div>
            </div>
            <div class="modal-footer">
                <div class="btn-group">
                    <button
                        type="button"
                        class="btn btn-primary"
                        [disabled]="(selectedDocuments || []).length == 0"
                        (click)="addDocuments(selectedDocuments)"
                    >
                        Add
                    </button>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        (click)="cancel()"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div
    class="modal fade"
    id="drawingregister-modal-{{ to.id }}"
    tabindex="-1"
    role="dialog"
    #drawingRegistersModal
>
    <div class="modal-dialog dw-modal" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="mb-0">Document Register</h3>
                <button
                    type="button"
                    class="btn-close"
                    #drawingRegisterButton_Close
                    data-bs-dismiss="modal"
                    aria-label="Close"
                >
                </button>
            </div>
            <div class="modal-body">
                <data-table
                    [dataset]="drawingRegisters"
                    (onRowSelected)="rowSelected($event)"
                    (onRowUnselected)="rowUnselected($event)"
                    (onHeaderCheckboxClicked)="onHeaderCheckboxClicked($event)"
                >
                    <column
                        frozen="true"
                        [mobileFreezeWidth]="750"
                        width="35px"
                        [header]="'Select'"
                        [value]="'selected'"
                        [type]="'CheckBox'"
                        [filterable]="false"
                        [editable]="true"
                        [selectionMode]="'multiple'"
                        [sortable]="false"
                    ></column>
                    <column
                        frozen="true"
                        [unfrozenOnMobile]="true"
                        [mobileFreezeWidth]="750"
                        [value]="'name'"
                        [header]="'Name'"
                        [width]="'250px'"
                        [type]="'HyperLink'"
                    ></column>
                    <column
                        frozen="true"
                        [unfrozenOnMobile]="true"
                        [mobileFreezeWidth]="750"
                        [value]="'revision'"
                        [width]="'100px'"
                        [header]="'Revision'"
                    ></column>
                    <column
                        [value]="'secondaryFiles'"
                        [type]="'Attachments'"
                        [tooltip]="'Secondary Files'"
                        [width]="'50px'"
                        [filterable]="false"
                        [sortable]="false"
                        [styleClass]="'text-center'"
                    ></column>
                    <column
                        [value]="'description'"
                        [width]="'250px'"
                        [header]="'Description'"
                    ></column>
                    <column
                        [value]="'type'"
                        [width]="'100px'"
                        [header]="'Type'"
                    ></column>
                    <column
                        [value]="'source'"
                        [width]="'100px'"
                        [header]="'Source'"
                    ></column>
                    <column
                        [value]="'structuredRefs'"
                        [header]="'Structure Reference'"
                    ></column>
                    <column
                        [value]="'elements'"
                        [header]="'Elements'"
                        [visible]="showLookups_Elements"
                    ></column>
                    <column
                        [value]="'levels'"
                        [header]="'Level'"
                        [visible]="showLookups_Levels"
                    ></column>
                    <column
                        [value]="'elevations'"
                        [header]="'Elevations'"
                        [visible]="showLookups_Elevations"
                    ></column>
                    <column
                        [value]="'cores'"
                        [header]="'Cores'"
                        [visible]="showLookups_Cores"
                    ></column>
                    <column
                        [value]="'packages'"
                        [header]="'Packages'"
                        [visible]="showLookups_Packages"
                    ></column>
                    <column
                        [value]="'drawingRegisterStatus'"
                        [header]="'Drawing Status'"
                        [visible]="showLookups_Statuses"
                    ></column>
                    <!-- <column
                        [value]="'dateTimeIssued'"
                        [type]="'Date'"
                        [header]="'Date Issued'"
                    ></column> -->
                    <column
                        [value]="'notes'"
                        [width]="'250px'"
                        [header]="'Notes'"
                    ></column>
                    <column
                        [value]="'lastUpdatedByFullName'"
                        [header]="'Last Updated By'"
                    ></column>
                    <column
                        [value]="'lastUpdateDate'"
                        [type]="'Date'"
                        [header]="'Last Updated'"
                    ></column>
                    <column
                        [value]="'status'"
                        [width]="'100px'"
                        [header]="'Status'"
                    ></column>
                </data-table>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-2 mb-2"
                        [disabled]="
                        (!selectedPrimaryFiles ||
                        selectedPrimaryFiles.length == 0) && (!selectedSecondaryFiles ||
                        selectedSecondaryFiles.length == 0)
                    "
                        (click)="addAllSelectedFiles($event)">
                    Add All Selected
                </button>
                <button class="btn btn-primary me-2 mb-2"
                        [disabled]="
                        !selectedPrimaryFiles ||
                        selectedPrimaryFiles.length == 0
                    "
                        (click)="addPrimaryFiles($event)">
                    Add Primary Files
                </button>
                <button class="btn btn-primary me-2 mb-2"
                        [disabled]="
                        !selectedSecondaryFiles ||
                        selectedSecondaryFiles.length == 0
                    "
                        (click)="addSecondaryFiles($event)">
                    Add Secondary Files
                </button>
                <button type="button"
                        class="btn btn-secondary mb-2"
                        (click)="cancelDrawingRegisters($event)">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
